(() => {
  if (customElements.get('bb-product-experience')) return;
  class ProductExperience extends HTMLElement {
    connectedCallback() {
      if (!this.classList.contains('bbp') || this.abort) return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.gallery = this.querySelector('swiper-container[id^="gallery-main-product-"]');
      this.thumbnails = [...this.querySelectorAll('[data-bbp-media]')];
      this.dialog = this.querySelector('.bbp-zoom');
      const syncGallery = () => this.syncGallery();
      this.gallery?.addEventListener('swiperinit', syncGallery, { signal });
      this.gallery?.addEventListener('swiperslidechange', syncGallery, { signal });
      window.addEventListener('load', syncGallery, { signal, once: true });
      this.thumbnails.forEach(button => button.addEventListener('click', () => {
        const swiper = this.gallery?.swiper;
        if (!swiper?.initialized) return;
        const index = [...swiper.slides].findIndex(slide => slide.dataset.id === button.dataset.bbpMedia);
        if (index >= 0) swiper.slideTo(index);
      }, { signal }));
      this.querySelectorAll('[data-bbp-step]').forEach(button => button.addEventListener('click', () => {
        const swiper = this.gallery?.swiper;
        if (!swiper?.initialized) return;
        Number(button.dataset.bbpStep) < 0 ? swiper.slidePrev() : swiper.slideNext();
      }, { signal }));
      this.querySelector('[data-bbp-zoom]')?.addEventListener('click', () => this.zoom(), { signal });
      this.gallery?.addEventListener('click', event => {
        if (event.target.closest('figure')?.querySelector('img')) this.zoom();
      }, { signal });
      this.querySelector('[data-bbp-close]')?.addEventListener('click', () => this.dialog.close(), { signal });
      this.dialog?.addEventListener('click', event => { if (event.target === this.dialog) this.dialog.close(); }, { signal });
      this.dialog?.addEventListener('close', () => this.zoomTrigger?.focus({ preventScroll: true }), { signal });
      const media = this.querySelector('.main-product__media');
      const heading = document.createElement('div');
      heading.className = 'bbp-mobile-heading';
      media?.before(heading);
      const moved = [...this.querySelectorAll('.main-product__title, .main-product__price')].map(node => {
        const anchor = document.createElement('span');
        anchor.hidden = true;
        node.before(anchor);
        return { node, anchor };
      });
      const mobile = window.matchMedia('(max-width: 749px)');
      const placeHeading = () => moved.forEach(({ node, anchor }) => {
        if (mobile.matches) heading.append(node);
        else anchor.after(node);
      });
      mobile.addEventListener('change', placeHeading, { signal });
      placeHeading();
      const strip = this.querySelector('.bbp-thumbnails');
      const count = this.querySelector('.bbp-gallery-toolbar > span');
      if (strip && count) {
        const toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = 'bbp-photos-toggle';
        toggle.textContent = count.textContent.trim();
        toggle.setAttribute('aria-expanded', 'false');
        strip.id ||= `bbp-thumbnails-${this.dataset.productId}`;
        toggle.setAttribute('aria-controls', strip.id);
        count.after(toggle);
        toggle.addEventListener('click', () => {
          const expanded = toggle.getAttribute('aria-expanded') !== 'true';
          toggle.setAttribute('aria-expanded', String(expanded));
          strip.classList.toggle('bbp-thumbnails-open', expanded);
        }, { signal });
      }
      const bar = this.querySelector('[data-bbp-buy-bar]');
      const buy = this.querySelector('.main-product__add-to-cart');
      if (bar && buy) {
        const action = this.querySelector('[data-bbp-return]');
        const barPrice = this.querySelector('[data-bbp-bar-price]');
        const barTitle = bar.querySelector('strong');
        const fallbackLabel = action.textContent.trim();
        const nativeButton = () => buy.querySelector('button[name="add"]');
        const personalizer = () => buy.querySelector('.pplr-c-button');
        const requiresPersonalizer = () => buy.querySelector('form[data-bb-modal-personalizer="true"]');
        const visible = el => !!el && el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden';
        const syncBar = () => {
          const native = nativeButton();
          const custom = personalizer();
          const target = visible(custom) ? custom : native;
          const rect = target?.getBoundingClientRect();
          bar.hidden = !mobile.matches || !!(rect && rect.top >= 0 && rect.bottom <= innerHeight);
          const disabled = !native || native.disabled || native.getAttribute('aria-disabled') === 'true' || native.classList.contains('loading');
          const needsCustom = !!requiresPersonalizer();
          action.disabled = disabled || (needsCustom && (!visible(custom) || custom.disabled));
          const text = needsCustom && visible(custom) ? custom.textContent.trim() : native?.querySelector('span:not(.icon)')?.textContent.trim();
          const label = text || native?.getAttribute('aria-label') || fallbackLabel;
          if (action.textContent !== label) action.textContent = label;
          const price = this.querySelector('.main-product__price');
          const value = price?.querySelector('.price--on-sale .price-item--sale, .price:not(.price--on-sale) .price__regular .price-item--regular');
          if (value && barPrice.textContent !== value.textContent.trim()) barPrice.textContent = value.textContent.trim();
          const selected = [...this.querySelectorAll('variant-selects input:checked, variant-selects select')].map(el => el.value).filter(Boolean).join(' / ');
          const title = selected || this.querySelector('h1')?.textContent.trim();
          if (title && barTitle.textContent !== title) barTitle.textContent = title;
        };
        const scheduleBar = () => {
          if (this.barFrame) return;
          this.barFrame = requestAnimationFrame(() => { this.barFrame = null; syncBar(); });
        };
        this.buyObserver = new MutationObserver(scheduleBar);
        this.buyObserver.observe(buy, { attributes: true, childList: true, subtree: true, characterData: true });
        const price = this.querySelector('.main-product__price');
        if (price) {
          this.priceObserver = new MutationObserver(scheduleBar);
          this.priceObserver.observe(price, { childList: true, subtree: true, characterData: true });
        }
        window.addEventListener('scroll', scheduleBar, { signal, passive: true });
        window.addEventListener('resize', scheduleBar, { signal, passive: true });
        this.addEventListener('change', scheduleBar, { signal });
        document.addEventListener('variant-update', scheduleBar, { signal });
        window.addEventListener('load', scheduleBar, { signal, once: true });
        action.addEventListener('click', () => {
          syncBar();
          if (action.disabled) return;
          const custom = personalizer();
          if (requiresPersonalizer()) {
            if (visible(custom) && !custom.disabled) custom.click();
            return;
          }
          const native = nativeButton();
          if (visible(custom)) custom.click();
          else if (native && !native.disabled) native.click();
        }, { signal });
        syncBar();
      }
      this.syncGallery();
    }
    syncGallery() {
      const swiper = this.gallery?.swiper;
      if (!swiper?.initialized) return;
      const slide = swiper.slides[swiper.activeIndex];
      if (!slide) return;
      this.thumbnails.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.bbpMedia === slide.dataset.id)));
      const active = this.thumbnails.find(button => button.dataset.bbpMedia === slide.dataset.id);
      if (active) {
        const strip = active.parentElement;
        const offset = active.offsetLeft - strip.offsetLeft;
        if (offset < strip.scrollLeft || offset + active.offsetWidth > strip.scrollLeft + strip.clientWidth) strip.scrollTo({ left: Math.max(0, offset - strip.clientWidth / 2 + active.offsetWidth / 2), behavior: 'instant' });
      }
      [...swiper.slides].forEach(item => { item.inert = item !== slide; });
      const previous = this.querySelector('[data-bbp-step="-1"]');
      const next = this.querySelector('[data-bbp-step="1"]');
      if (previous) previous.disabled = swiper.isBeginning;
      if (next) next.disabled = swiper.isEnd;
      const zoom = this.querySelector('[data-bbp-zoom]');
      if (zoom) zoom.hidden = !slide.querySelector('figure>img');
    }
    zoom() {
      const swiper = this.gallery?.swiper;
      const slide = swiper?.slides?.[swiper.activeIndex] || this.gallery?.querySelector('swiper-slide');
      const source = slide?.querySelector('figure>img');
      if (!source || !this.dialog || this.dialog.open) return;
      this.zoomTrigger = this.contains(document.activeElement) && document.activeElement !== document.body ? document.activeElement : this.querySelector('[data-bbp-zoom]');
      const img = source.cloneNode();
      img.removeAttribute('class');
      img.removeAttribute('style');
      img.removeAttribute('loading');
      this.dialog.querySelector('[data-bbp-zoom-image]').replaceChildren(img);
      this.dialog.showModal();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.buyObserver?.disconnect();
      this.priceObserver?.disconnect();
      cancelAnimationFrame(this.barFrame);
      this.abort = null;
    }
  }
  customElements.define('bb-product-experience', ProductExperience);
})();
